import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Stage from '../stage/stage';
import BoothIcon from './booth-icon';

/** @class Hall
  * A component for rendering a hall in a virtual expo
  */
export default class Hall extends ReactFireComponent {
  /** @constructor
    * Creates a new Hall instance.
    */
  constructor(props) {
    super(props);
    this.state = {booths: []}
  }
  /** @method componentWillMount
    * Binds the hall state to the firebase database.
    */
  componentWillMount() {
    this.bindAsArray(this.props.dataURL + '/booths', 'booths');
  }
  /** @method componentWillUnmount
    * Unbinds the hall state from the firebase database.
    */
  componentWillUnmount() {
    this.unbind('booths');
  }
  /** @method render
    * Renders the Hall.
    */
  render() {
    const boothIcons = this.state.booths.map(booth => (
      <BoothIcon key={booth.id} {...booth} />
    ));
    return (
      <Stage dataURL={this.props.dataURL + '/stage'}>
        {boothIcons}
      </Stage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hall/hall.js